import CATEGORY_LISTING_PAGE_CONSTANTS from './CategoryListingPage.constants';
// import {categoryData} from './mock';

const initialState = {
  isPaginatedPlpLoading: false,
  currentPageNumber: 1,
  paginatedPlpProducts: [],
  totalProductsCount: 100,
  isHorizontalPlpEnabled: false,
  defaultCacheTime: 600000, // in ms
  cachedAt: 0, // in ms
  pagesToBeCached: 5,
  serviceErrorFlag: false,
  isAlternatePlpEnabled: false,
  isPaginatedAlternatePlpEnabled: false,
  isSeoHeaderCopyLoaded: false,
  plpSeoToken: null,
  isStageHoldCategory: false,
  subCatFacetList: [],
  isBucketLoading: false,
  isSubCatFilterMapsLoaded: false,
  isSubCategoryFilterLoading: false,
};

const cachedPages = (pageCount, products, page) => {
  const productList = products;
  const prodLen = productList.length;
  if (pageCount < prodLen) {
    const loop1 = page - 1 - Math.ceil(pageCount / 2);
    const loop2 = page + Math.floor(pageCount / 2);
    for (let i = 0; i < loop1; ) {
      productList[i] = [];
      i += 1;
    }
    for (let i = loop2; i < prodLen; ) {
      productList[i] = [];
      i += 1;
    }
  }
  return productList;
};

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const CategoryListingPageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_LOADED_PRODUCTS: {
      const { data, page, isHydrating } = action.payload || {};
      let paginatedPLP = isHydrating ? [] : [...state.paginatedPlpProducts] || [];
      paginatedPLP[page - 1] = data;
      paginatedPLP = cachedPages(state.pagesToBeCached, paginatedPLP, page);
      const cachedAtMs = state.cachedAt ? state.cachedAt : Date.now();
      return { ...state, paginatedPlpProducts: paginatedPLP, cachedAt: cachedAtMs };
    }
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_LOADED_PAGINATED_PRODUCTS: {
      const { data = [], page, isHydrating } = action.payload || {};

      let paginatedPLP = isHydrating ? [] : [...state.paginatedPlpProducts] || [];
      paginatedPLP[page - 1] = [...(paginatedPLP[page - 1] || []), ...data];
      if (isHydrating) {
        paginatedPLP = cachedPages(state.pagesToBeCached, paginatedPLP, page);
      }
      return {
        ...state,
        isPaginatedPlpLoading: false,
        paginatedPlpProducts: paginatedPLP,
        cachedAt: state.cachedAt || Date.now(),
      };
    }
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_PAGINATED_CONSOLIDATED_RES_DATA:
      return { ...state, ...action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_PRODUCT_LOADING_FLAG:
      if (!state?.isProductLoadingFlag && !action?.payload) return state;
      return { ...state, isProductLoadingFlag: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_PAGINATED_PLP_LOADING:
      return { ...state, isPaginatedPlpLoading: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_CURRENT_NAV_IDS:
      return { ...state, navcurrentNavIds: action.payload.activeCategoryIds };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_CURRENT_PAGE:
      return { ...state, currentPageNumber: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_HORIZONTAL_PLP_FLAG:
      return { ...state, isHorizontalPlpEnabled: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_PLP_SEO_TOKEN_LIST:
      return { ...state, plpSeoToken: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_BOPIS_FILTER_STATE:
      return {
        ...state,
        isBopisFilterOn: action.payload,
      };
    case CATEGORY_LISTING_PAGE_CONSTANTS.RESET_PAGINATED_PRODUCTS:
      return { ...state, paginatedPlpProducts: [], cachedAt: 0 };
    case CATEGORY_LISTING_PAGE_CONSTANTS.RESET_CACHED_AT:
      return { ...state, cachedAt: 0 };
    case CATEGORY_LISTING_PAGE_CONSTANTS.RESET_SEO_HEADER_COPY_LOADED_FLAG:
      return { ...state, isSeoHeaderCopyLoaded: false };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_PAGE_SEO_DATA: {
      const {
        payload: {
          response: {
            categorySeoData: {
              seoTitle = '',
              seoMetaDesc = '',
              canonicalUrl = '',
              longDescription = '',
              seoHeaderCopy = '',
              seoPageDirective = '',
            } = {},
          } = {},
        } = {},
      } = action;
      return {
        ...state,
        seoTitle,
        seoMetaDesc,
        canonicalUrl,
        longDescription,
        seoHeaderCopy,
        isSeoHeaderCopyLoaded: true,
        seoPageDirective,
      };
    }
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_SERVICE_ERROR_FLAG: {
      return { ...state, serviceErrorFlag: action.payload };
    }
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_ALTERNATE_PLP_FLAG:
      return { ...state, isAlternatePlpEnabled: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_PAGINATED_ALTERNATE_PLP_FLAG:
      return { ...state, isPaginatedAlternatePlpEnabled: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.UPDATE_APPLIED_FILTERS:
      return { ...state, appliedFilters: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.UPDATE_FILTERS_FROM_URL:
      return { ...state, filtersFromURL: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_FROM_HPLP:
      return { ...state, fromHplp: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_STAGE_HOLD_CATEGORY:
      return { ...state, isStageHoldCategory: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_CATEGORY_MODULE_FILTERS:
      return { ...state, catModulesFilters: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_PRICE_FILTER_FLAG:
      return { ...state, priceFilterFlag: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_QUICK_FILTER:
      return { ...state, quickFilters: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_SUB_CAT_FILTER_MAP_DATA:
      return { ...state, subCatFilterMaps: action.payload, isSubCatFilterMapsLoaded: true };
    case CATEGORY_LISTING_PAGE_CONSTANTS.RESET_SUB_CAT_FILTER_MAP_LOADING_FLAG:
      return { ...state, isSubCatFilterMapsLoaded: false };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_SUB_CATEGORY_FILTER_LOADING:
      return { ...state, isSubCategoryFilterLoading: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_BUCKET_LOADING_FLAG:
      return { ...state, isBucketLoading: action.payload };
    case CATEGORY_LISTING_PAGE_CONSTANTS.SET_SUB_CAT_FACET_LIST: {
      const { name, list } = action.payload;
      const existingIndex = state.subCatFacetList.findIndex((item) => item.name === name);

      let updatedList;
      if (existingIndex !== -1) {
        updatedList = state.subCatFacetList.map((item, index) =>
          index === existingIndex ? { ...item, list } : item
        );
      } else {
        updatedList = [...state.subCatFacetList, { name, list }];
      }

      return { ...state, subCatFacetList: updatedList };
    }

    default: {
      return state;
    }
  }
};

export default CategoryListingPageReducer;
